<script>
  import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Spinner
  } from "sveltestrap";
  import axios from "axios";
  import { onMount, createEventDispatcher } from "svelte";
  import { ListGroup, ListGroupItem } from "sveltestrap";
  export let open;
  export let toggle;
  export let teamId;
  export let data;
  let isTeamMember = true;
  let resourceAssigned = null;
  let resource = null;
  let focus = true;
  let resource_id;
  let resource_name;
  let saving = false;
  let resourcelist = [];
  let projectManagerId;
  let mapresource = null;
  let inContact = false;
  let typedResource = [];
  const onFocus = () => (focus = true);

  const dispatch = createEventDispatcher();

  function AddResource() {
    saving = true;
    let noProjectManager;
    if(projectManagerId!=null)
    {
      noProjectManager =  resourcelist.filter(x=>x.resource_id != projectManagerId.resource_id);
    }
    else
    {
      noProjectManager = resourcelist.filter(x=>x.resource_id != null );
    }
    resourcelist = resourcelist;
    const lists = noProjectManager.map(x => x.resource_id);
    var bodyFormData = new FormData();

    bodyFormData.set("jobId", data.JobID);
    bodyFormData.set("deliverableId", data.DeliverableId);
    bodyFormData.set("resourceIds", lists);
    if(projectManagerId!=null)
    {
      bodyFormData.set("projectManagerId", projectManagerId.resource_id);
    }
    axios({
      method: "post",
      url: "/resourceapi/MultipleAddResource",
      data: bodyFormData,
      headers: { "Content-Type": "multipart/form-data" }
    })
      .then(function(response) {
        saving = false;
        resource = "";
        resourcelist = [];
        mapresource = null;
        dispatch('contactUpdated');
        toggle();
      })
      .catch(function(response) {
        //handle error
        console.log(response);
      });
  }
  function handleChangeResource(e) {
    resource = e.target.value;
    GetContact(resource);
    if(resourceAssigned!=null)
    {
      typedResource = resourceAssigned.find(x=>x.FullName.toLowerCase() == resource.toLowerCase());
      if(typedResource===undefined)
      {
        inContact = false;
      }
      else
      {
        inContact = true;
        resource_id = typedResource.ContactId;
        focus = false;
      }
    }

  }
  function GetContact(resource) {
    if (teamId == "") {
      isTeamMember = false;
    }
    axios
      .get(
        "/jobboardapi/GetContacts?name=" +
          resource +
          "&isTeamMember=" +
          false +
          "&team=" +
          ""
      )
      .then(function(response) {
        resourceAssigned = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  function handleChangeValueIsTeamMember(e) {
    isTeamMember = e.target.value;
  }

  function handlePassId(id, name) {
    focus = false;
    resource_id = id;
    resource = name;
    inContact = true;
  }

  function handleAddResource() {
    resourcelist.push({ resource_id, resource });
    resourcelist = resourcelist;
    mapresource = resourcelist.map(x => x.resource);
    resource_id = "";
    resource = "";
    inContact = false;
  }

  function handleCancel() {
    resource_id = "";
    resource = "";
    resourcelist = [];
    mapresource = null;
    saving = false;
    toggle();
  }

  function checkRadioBtn(){
    if(projectManagerId!=null){
        projectManagerId = null;
    }
  }
</script>

<style>
  .listgroup-style {
    overflow-y: scroll;
    max-height: 400px;
    position: absolute;
    border: 1px solid #4bcffa;
  }
  .listgroup-style::-webkit-scrollbar {
    display: none;
  }
  .listitem-style {
    width: auto;
    max-width: 465.5px;
    min-width: 465.5px;
  }
  input {
    width: 85%;
    padding: 10px;
    border: 1px solid #b2bec3;
    border-radius: 5px;
  }
  button {
    width: 14%;
    color: white;
    padding: 10px;
    border: none;
    background-color: #3498db;
    border-radius: 5px;
  }
  button:disabled{
    width: 14%;
    color: white;
    padding: 10px;
    border: none;
    background-color: #b2bec3;
    border-radius: 5px;
  }
</style>

<Modal isOpen={open} {toggle}>
  <ModalHeader {toggle}>Add Contact</ModalHeader>
  <ModalBody>
    {#if resourcelist !== null}
      {#each resourcelist as resource}
        <ListGroup flush style="margin-bottom: 20px">
          <ListGroupItem style="display: flex">{resource.resource}<input type=radio bind:group={projectManagerId} on:click={checkRadioBtn} value={resource} style="width: 10%; margin-left: auto;
          margin-top: 5px"> Assign as Project Manager</ListGroupItem>
        </ListGroup>
      {/each}
    {/if}
    <input
      type="text"
      placeholder="Contacts"
      value={resource}
      on:keyup={handleChangeResource}
      on:focus={onFocus} />
    <input type="text" value={resource_id} hidden />
    {#if resourceAssigned !== null}
      {#if resource !== ''}
        {#if focus}
          <div class="listgroup-style">
            <ListGroup>
              {#each resourceAssigned as resource}
                <div class="listitem-style">
                  <ListGroupItem
                    tag="button"
                    action
                    key={resource.ContactId}
                    on:click={handlePassId(resource.ContactId, resource.FullName)}>
                    {resource.FullName}
                  </ListGroupItem>
                </div>
              {/each}
            </ListGroup>
          </div>
        {/if}
      {/if}
    {/if}
    {#if resource_id !== '' || resource_id !== null}
      <button
        on:click={handleAddResource}
        disabled={inContact? false : true}>
        Add
      </button>
    {/if}

  </ModalBody>
  <ModalFooter>
    {#if saving}
      <Button color="primary" disabled>
        <Spinner size="sm" />
        Saving
      </Button>
    {:else}
      <Button color="primary" on:click={AddResource}>Save</Button>
    {/if}
    <Button color="secondary" on:click={handleCancel}>Cancel</Button>
  </ModalFooter>
</Modal>
